import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { iconByReturnInstructionType, labelByReturnInstructionType } from '../constants'
import ReturnInstructionItemMenu from './ReturnInstructionItemMenu/ReturnInstructionItemMenu'
import * as Styles from './styles'

const ReturnInstructionItem = ({ data, onEdit, onDuplicate, onDelete, isEditable }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const Icon = iconByReturnInstructionType[data?.type]

  const handleClick = () => onEdit(data)

  return (
    <Styles.MainContainer onClick={handleClick}>
      <Styles.InternalIdContainer>
        <Text type="bodyMBold" color={theme.colors.text.subtle}>
          #{data?.internal_id}
        </Text>
      </Styles.InternalIdContainer>
      <Styles.InfoContainer>
        <Styles.HeaderContainer>
          <Styles.TitleContainer>
            {Icon && (
              <Tooltip title={t(labelByReturnInstructionType[data?.type])}>
                <Icon size={24} />
              </Tooltip>
            )}
            <Text type="titleS">{data?.name}</Text>
          </Styles.TitleContainer>
          {isEditable && (
            <ReturnInstructionItemMenu data={data} onEdit={onEdit} onDuplicate={onDuplicate} onDelete={onDelete} />
          )}
        </Styles.HeaderContainer>
      </Styles.InfoContainer>
    </Styles.MainContainer>
  )
}

export default ReturnInstructionItem
